export const supportData = [
  {
    id: 1,
    image: "user/5.jpg",
    name: "Airi Satou",
    position: "Accountant",
    salary: "$162,700",
    office: "Tokyo",
    skill: 70,
    extn: 5407,
    email: "a.satou@datatables.net",
    color: "success",
  },

  {
    id: 2,
    image: "user/7.jpg",
    name: "Ashton Cox",
    position: "Junior Technical Author",
    salary: "$86,000",
    office: "San Francisco",
    skill: 60,
    extn: 1562,
    email: "a.cox@datatables.net",
    color: "danger",
  },

  {
    id: 3,
    image: "user/6.jpg",
    name: "Bradley Greer",
    position: "Software Engineer",
    salary: "$132,000",
    office: "London",
    skill: 30,
    extn: 2558,
    email: "b.greer@datatables.net",
    color: "primary",
  },

  {
    id: 4,
    image: "user/11.png",
    name: "Brielle Williamson",
    position: "Integration Specialist",
    salary: "$372,000",
    office: "New York",
    skill: 55,
    extn: 4804,
    email: "b.williamson@datatables.net",
    color: "info",
  },

  {
    id: 5,
    image: "user/4.jpg",
    name: "Caesar Vance",
    position: "Pre-Sales Support",
    salary: "$106,450",
    office: "New York",
    skill: 20,
    extn: 8330,
    email: "c.vance@datatables.net",
    color: "success",
  },

  {
    id: 6,
    image: "user/1.jpg",
    name: "Cedric Kelly",
    position: "Senior Javascript Developer",
    salary: "$433,060",
    office: "Edinburgh",
    skill: 50,
    extn: 6224,
    email: "c.kelly@datatables.net",
    color: "secondary",
  },

  {
    id: 7,
    image: "user/8.jpg",
    name: "Charde Marshall",
    position: "Regional Director",
    salary: "$470,600",
    office: "San Francisco",
    skill: 80,
    extn: 6741,
    email: "c.marshall@datatables.net",
    color: "info",
  },

  {
    id: 8,
    image: "user/8.jpg",
    name: "Colleen Hurst",
    position: "Javascript Developer",
    salary: "$205,500",
    office: "San Francisco",
    skill: 100,
    extn: 6224,
    email: "c.hurst@datatables.net",
    color: "success",
  },

  {
    id: 9,
    image: "user/2.png",
    name: "Dai Rios",
    position: "Personnel Lead",
    salary: "$217,500",
    office: "Edinburgh",
    skill: 24,
    extn: 2290,
    email: "d.rios@datatables.net",
    color: "warning",
  },

  {
    id: 10,
    image: "user/11.png",
    name: "Garrett Winters",
    position: "Accountant",
    salary: "$170,750",
    office: "Tokyo",
    skill: 40,
    extn: 8422,
    email: "g.winters@datatables.net",
    color: "secondary",
  },

  {
    id: 11,
    image: "user/6.jpg",
    name: "Gloria Little",
    position: "Systems Administrator",
    salary: "$237,500",
    office: "New York",
    skill: 40,
    extn: 1721,
    email: "g.little@datatables.net",
    color: "success",
  },

  {
    id: 12,
    image: "user/2.png",
    name: "Haley Kennedy",
    position: "Senior Marketing Designer",
    salary: "$313,500",
    office: "London",
    skill: 15,
    extn: 3597,
    email: "h.kennedy@datatables.net",
    color: "danger",
  },

  {
    id: 13,
    image: "user/7.jpg",
    name: "Herrod Chandler",
    position: "Sales Assistant",
    salary: "$137,500",
    office: "San Francisco",
    skill: 50,
    extn: 9608,
    email: "h.chandler@datatables.net",
    color: "primary",
  },

  {
    id: 14,
    image: "user/11.png",
    name: "Jena Gaines",
    position: "Office Manager",
    salary: "$90,560",
    office: "London",
    skill: 80,
    extn: 3814,
    email: "j.gaines@datatables.net",
    color: "info",
  },

  {
    id: 15,
    image: "user/9.jpg",
    name: "Jenette Caldwell",
    position: "Development Lead",
    salary: "$345,000",
    office: "New York",
    skill: 80,
    extn: 1937,
    email: "j.caldwell@datatables.net",
    color: "success",
  },

  {
    id: 16,
    image: "user/4.jpg",
    name: "Michael Silva",
    position: "Marketing Designer",
    salary: "$198,500",
    office: "London",
    skill: 20,
    extn: 1581,
    email: "m.silva@datatables.net",
    color: "secondary",
  },
  {
    id: 17,
    image: "user/5.jpg",
    name: "Paul Byrd",
    position: "Chief Financial Officer (CFO)",
    salary: "$725,000",
    office: "New York",
    skill: 20,
    extn: 3059,
    email: "p.byrd@datatables.net",
    color: "info",
  },
  {
    id: 18,
    image: "user/12.png",
    name: "Quinn Flynn",
    position: "Support Lead",
    salary: "$342,000",
    office: "Edinburgh",
    skill: 10,
    extn: 9497,
    email: "q.flynn@datatables.net",
    color: "success",
  },
  {
    id: 19,
    image: "user/8.jpg",
    name: "Rhona Davidson",
    position: "Integration Specialist",
    salary: "$327,900",
    office: "Tokyo",
    skill: 10,
    extn: 6200,
    email: "r.davidson@datatables.net",
    color: "warning",
  },
  {
    id: 20,
    image: "user/10.jpg",
    name: "Sonya Frost",
    position: "Software Engineer",
    salary: "$103,600",
    office: "Edinburgh",
    skill: 10,
    extn: 1667,
    email: "s.frost@datatables.net",
    color: "secondary",
  },
  {
    id: 21,
    image: "user/3.png",
    name: "Tatyana Fitzpatrick",
    position: "Regional Director",
    salary: "$385,750",
    office: "London",
    skill: 30,
    extn: 1667,
    email: "t.fitzpatrick@datatables.net",
    color: "success",
  },
  {
    id: 22,
    image: "user/1.jpg",
    name: "Tiger Nixon",
    position: "System Architect",
    salary: "$320,800",
    office: "Edinburgh",
    skill: 30,
    extn: 5421,
    email: "t.nixon@datatables.net",
    color: "danger",
  },
  {
    id: 23,
    image: "user/10.jpg",
    name: "Yuri Berry",
    position: "Chief Marketing Officer (CMO)",
    salary: "$675,000",
    office: "New York",
    skill: 60,
    extn: 6154,
    email: "y.berry@datatables.net",
    color: "primary",
  },
];

export const supportColumns = [
  {
    name: "Image",
    selector: (row) => row["image"],
    sortable: true,
  },
  {
    name: "Position",
    selector: (row) => row["position"],
    sortable: true,
  },
  {
    name: "Salary",
    selector: (row) => row["salary"],
    sortable: true,
  },
  {
    name: "Office",
    selector: (row) => row["office"],
    sortable: true,
  },
  {
    name: "Skill",
    selector: (row) => row["skill"],
    sortable: true,
  },
  {
    name: "Extn",
    selector: (row) => row["extn"],
    sortable: true,
  },
  {
    name: "Email",
    selector: (row) => row["email"],
    sortable: true,
  },
];

export const TicketData = [
  {
    id: 1,
    title: "Order",
    num: "2563",
    class: "progress-bar bg-primary",
  },
  {
    id: 2,
    title: "Pending",
    num: "8943",
    class: "progress-bar bg-secondary",
  },
  {
    id: 3,
    title: "Running",
    num: "2500",
    class: "progress-bar bg-warning",
  },
  {
    id: 4,
    title: "Smooth",
    num: "2060",
    class: "progress-bar bg-info",
  },
  {
    id: 5,
    title: "Done",
    num: "5600",
    class: "progress-bar bg-success",
  },
  {
    id: 6,
    title: "Cancel",
    num: "2560",
    class: "progress-bar bg-danger",
  },
];
